import { useQueryClient } from "@tanstack/react-query";

import { candidateSheetV2TabCountsQueryKey } from "@/lib/constants";
import { novaClient } from "@/lib/trpc";

export function useCreateAddUserNote() {
  const novaClientUtils = novaClient.useUtils();
  const queryClient = useQueryClient();

  return novaClient.internal.user.note.create.useMutation({
    onSuccess: (createdNote) => {
      novaClientUtils.internal.user.note.list.setData(
        { userId: createdNote.userId },
        (cachedNotes) =>
          cachedNotes ? [createdNote, ...cachedNotes] : cachedNotes,
      );
      void queryClient.invalidateQueries({
        queryKey: candidateSheetV2TabCountsQueryKey,
      });
    },
  });
}
